module.exports = __webpack_public_path__ + "img/nodejs_white-color.6388e566.svg";